import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTwitter} from '@fortawesome/free-brands-svg-icons'

import type {SizeProp} from '@fortawesome/fontawesome-svg-core'

interface FaTwitterProps {
  text?: string
  textIsBefore?: boolean
  showIconText?: boolean
  size?: SizeProp
}

const FaTwitter = ({
  text,
  textIsBefore = false,
  showIconText = false,
  size = 'sm',
}: FaTwitterProps) => {
  let renderDOM = (
    <span className='icon'>
      <FontAwesomeIcon icon={faTwitter} size={size} />
    </span>
  )
  if (text) {
    renderDOM = (
      <span
        className='icon-text'
        style={{flexWrap: 'nowrap'}}
      >
        {textIsBefore && showIconText && <span>{text}</span>}
        <span className='icon'>
          <FontAwesomeIcon icon={faTwitter} size={size} />
        </span>
        {!textIsBefore && showIconText && <span>{text}</span>}
      </span>
    )
  }
  return renderDOM
}

export default FaTwitter
